export const SAVE_TO_RECORD_CHECKBOX_ID = "save-to-record-toggle";
